function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { to, animated } from '@react-spring/web';
import Alert from '@reach/alert';
import Flex from '../Flex/Flex';
import Box from '../Box/Box';
import { P, H4 } from '../Text/Text';
import { useVelocityTrackedSpring } from '../../utils';
import ThemeProvider from '../../ThemeProvider';
import useTheme from '../../useTheme';
import { CloseIcon } from '../Icons/generated';
import TertiaryIconButton from '../../2/TertiaryIconButton';
export var SnackbarContainer = styled(Flex).withConfig({
  displayName: "Snackbar__SnackbarContainer",
  componentId: "sc-11tnci8-0"
})(["flex-direction:column;padding:1em;position:fixed;bottom:0;left:0;right:0;z-index:100;", "{bottom:3vh;left:3vw;right:auto;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.mediaQueries.desktop;
});
var StyledSnackbar = styled(Box).withConfig({
  displayName: "Snackbar__StyledSnackbar",
  componentId: "sc-11tnci8-1"
})(["width:100%;padding:", ";border-radius:", ";box-shadow:", ";"], function (p) {
  return p.theme.space.m;
}, function (p) {
  return p.theme.borderRadius.radius8;
}, function (p) {
  return p.theme.shadows.shadow16;
});
var yStops = [0, 120];
export function Snackbar(props) {
  var _useTheme = useTheme(),
      themeKey = _useTheme.themeKey;

  var _useVelocityTrackedSp = useVelocityTrackedSpring(function () {
    return {
      y: yStops[1]
    };
  }),
      _useVelocityTrackedSp2 = _slicedToArray(_useVelocityTrackedSp, 2),
      y = _useVelocityTrackedSp2[0].y,
      setY = _useVelocityTrackedSp2[1];

  var _useVelocityTrackedSp3 = useVelocityTrackedSpring(function () {
    return {
      x: 0
    };
  }),
      _useVelocityTrackedSp4 = _slicedToArray(_useVelocityTrackedSp3, 1),
      x = _useVelocityTrackedSp4[0].x;

  useEffect(function () {
    setY({
      y: yStops[0]
    });
  }, [setY]);

  function handleClick(e) {
    if (props.handleClick) {
      props.handleClick(e);
    }

    handleClose(e);
  }

  function handleClose(e) {
    e.stopPropagation();

    if (props.handleClose) {
      props.handleClose(e);
    }

    props.clearSnackbar();
  }

  return /*#__PURE__*/React.createElement(StyledSnackbar, {
    bg: props.backgroundColor,
    mt: "s",
    onClick: handleClick,
    as: props.handleClick ? animated.button : animated.div,
    style: {
      opacity: y.to(yStops, [1, 0]),
      transform: to([x, y], function (x, y) {
        return "translate3D(".concat(x, "px, ").concat(y, "px, 0px)");
      })
    },
    "data-testid": "snackbar"
  }, /*#__PURE__*/React.createElement(Flex, {
    as: Alert,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeKey
  }, props.icon && /*#__PURE__*/React.createElement(Box, {
    mr: "s"
  }, props.icon), /*#__PURE__*/React.createElement(Box, {
    flex: "1"
  }, props.title && /*#__PURE__*/React.createElement(H4, {
    color: props.textColor,
    mb: "min",
    textAlign: "left"
  }, props.title), props.body && /*#__PURE__*/React.createElement(P, {
    color: props.textColor,
    align: "left"
  }, props.body)), !props.duration && /*#__PURE__*/React.createElement(TertiaryIconButton, {
    size: "small",
    onClick: handleClose
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    color: props.textColor
  })))));
}
Snackbar.defaultProps = {
  backgroundColor: 'bgElevated',
  textColor: 'textPrimary',
  handleClose: function handleClose() {}
};
Snackbar.propTypes = {
  backgroundColor: PropTypes.string,
  handleClick: PropTypes.func,
  icon: PropTypes.node,
  textColor: PropTypes.string,
  body: PropTypes.string.isRequired,
  duration: PropTypes.number,
  handleClose: PropTypes.func.isRequired
};
export default Snackbar;